import { useEffect, useState } from "react";
import { getTokenExp } from "../utils/jwt";

export default function useAuthGuard() {
  const [expSoon, setExpSoon] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const expMs = getTokenExp(token);
    if (!expMs) {
      localStorage.removeItem("token");
      window.location.reload();
      return;
    }

    const now = Date.now();
    const left = expMs - now;

    // 이미 만료
    if (left <= 0) {
      localStorage.removeItem("token");
      alert("로그인이 만료되었습니다. 다시 로그인하세요.");
      window.location.reload();
      return;
    }

    // 5분 이내 만료 안내
    if (left <= 5 * 60 * 1000) {
      setExpSoon(true);
    }

    // 만료 타이머
    const t = setTimeout(() => {
      localStorage.removeItem("token");
      alert("로그인이 만료되었습니다. 다시 로그인하세요.");
      window.location.reload();
    }, left);

    return () => clearTimeout(t);
  }, []);

  return { expSoon };
}
